import { useTranslations } from "@/components/context/translations";

type FormReviewTopicsProps = {
  id: string;
  name: string;
  topics: string[];
};

export function FormReviewTopics({ ...props }: FormReviewTopicsProps) {
  const t = useTranslations();
  const label = t("Try covering these topics");
  const resolvedTopics = props.topics ?? [];

  const topics = resolvedTopics.map((topic) => t(topic));
  const numTopics = resolvedTopics.length;
  if (numTopics === 0) return null;

  return (
    <div>
      <p
        style={{
          fontSize: "var(--label-font-size)",
          fontFamily: "var(--label-font-name, var(--font-family))",
          fontStyle: "var(--label-font-style, var(--font-style))",
          fontWeight: "var(--label-font-weight, var(--font-weight))",
          color: "var(--label-color)",
        }}
        dangerouslySetInnerHTML={{
          __html: label,
        }}
      />
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          marginTop: "0.5rem",
        }}
      >
        {topics.map((topic, i) => (
          <div
            key={i}
            id={`chip-${i}`}
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "0.25rem 0.75rem",
              borderRadius: "9999px",
              border:
                "var(--field-border-size, 1px) solid var(--input-border-color)",
              color: "var(--input-color)",
              backgroundColor: "var(--input-background)",
              fontSize: "0.875rem",
            }}
          >
            <span>{topic}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
